import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className="py-20 px-4 max-w-4xl mx-auto text-center" data-id="element-147">
      <div className="space-y-6 mb-12" data-id="element-148">
        <p className="text-2xl text-white font-bold" data-id="element-149">👉 Sí.</p>
        <p className="text-2xl text-white font-bold" data-id="element-150">Todo esto…</p>
        <p className="text-2xl text-white font-bold" data-id="element-151">
          Por menos que una salida.
        </p>
        <p className="text-brand-red font-bold text-xl mt-8" data-id="element-152">
          ⚠️ Pero no por mucho tiempo.
        </p>
      </div>

      <div className="bg-gray-900 border-2 border-brand-red p-8 md:p-16 rounded-3xl shadow-[0_0_40px_rgba(220,38,38,0.2)]" data-id="element-153">
        <h2 className="text-4xl md:text-5xl font-heading text-white uppercase mb-8" data-id="element-154">
          🚨 ESTE PRECIO VA A SUBIR
        </h2>
        <div className="flex flex-col md:flex-row justify-center gap-6 text-gray-300 mb-10 text-lg font-medium" data-id="element-155">
          <span data-id="element-156">👉 Cuando haya más resultados</span>
          <span data-id="element-157">👉 Cuando haya más demanda</span>
        </div>

        <div className="mb-10 text-left max-w-sm mx-auto bg-gray-800/50 p-6 rounded-xl border border-gray-700" data-id="element-158">
          <ul className="space-y-3 text-white font-medium text-lg" data-id="element-159">
            <li data-id="element-160">✔️ Sistema completo de 5 módulos</li>
            <li data-id="element-161">✔️ 3 bonos exclusivos incluidos</li>
            <li data-id="element-162">✔️ Acceso de por vida</li>
            <li data-id="element-163">✔️ Garantía de 30 días</li>
          </ul>
        </div>

        <div className="mb-10" data-id="element-164">
          <p className="text-gray-500 line-through text-3xl mb-3 font-bold" data-id="element-165">
            $85.690
          </p>
          <div className="text-6xl md:text-8xl font-heading text-brand-green" data-id="element-166">
            <PriceDisplay amount={19990} data-id="element-167" />
          </div>
        </div>

        <p className="text-white font-bold text-2xl mb-6" data-id="element-168">
          👉 HACÉ CLICK Y EMPEZÁ AHORA
        </p>

        <a href="[CART_LINK]" className="block w-full text-center bg-brand-red hover:bg-brand-redHover text-white font-heading text-3xl md:text-4xl py-6 px-8 rounded-2xl transition-all transform hover:scale-[1.02] shadow-[0_0_30px_rgba(220,38,38,0.4)] mb-8" data-id="element-169">
          AGREGAR AL CARRITO
        </a>

        <div className="flex justify-center items-center space-x-6 text-gray-400 text-sm md:text-base mb-10" data-id="element-170">
          <div className="flex items-center" data-id="element-171">
            <LockIcon className="w-5 h-5 mr-2" data-id="element-172" />
            <span className="font-medium" data-id="element-173">Pago Seguro</span>
          </div>
          <span data-id="element-174">•</span>
          <div className="flex items-center space-x-4" data-id="element-175">
            <span className="font-bold tracking-wider" data-id="element-176">VISA</span>
            <span className="font-bold tracking-wider" data-id="element-177">MASTERCARD</span>
          </div>
        </div>

        <div className="bg-gray-800/50 p-8 rounded-2xl border-2 border-brand-gold text-left flex flex-col md:flex-row items-center md:items-start shadow-[0_0_15px_rgba(245,158,11,0.15)]" data-id="element-178">
          <ShieldCheckIcon className="w-16 h-16 text-brand-gold mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-179" />
          <div className="text-center md:text-left" data-id="element-180">
            <h3 className="text-xl mb-3 font-[800] text-[#FFFFFF]" data-id="element-181">
              GARANTÍA DE 30 DÍAS
            </h3>
            <p className="text-gray-300 mb-3 text-lg" data-id="element-182">Si no te sirve…</p>
            <ul className="text-gray-400 space-y-2 font-medium" data-id="element-183">
              <li data-id="element-184">👉 Te devuelvo el 100% del dinero</li>
              <li data-id="element-185">👉 Sin preguntas</li>
              <li data-id="element-186">👉 Sin vueltas</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-20 space-y-8 text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-187">
        <h3 className="text-3xl font-bold text-brand-red uppercase" data-id="element-188">
          ⚠️ ÚLTIMO AVISO
        </h3>
        <p data-id="element-189">Esto puede cambiar tu seguridad…</p>
        <p data-id="element-190">Tu rendimiento…</p>
        <p data-id="element-191">Y cómo te perciben.</p>
        <p className="py-6 font-bold text-white" data-id="element-192">O podés seguir igual.</p>

        <p className="text-3xl font-bold text-white uppercase mt-8" data-id="element-193">
          👉 LA DECISIÓN ES TUYA
        </p>

        <a href="[CART_LINK]" className="inline-block bg-brand-red hover:bg-brand-redHover text-white font-heading text-2xl py-5 px-16 rounded-xl transition-colors mt-6 shadow-lg" data-id="element-194">
          EMPEZAR AHORA
        </a>

        <div className="mt-16 text-left bg-gray-900 p-8 rounded-2xl border border-gray-800 shadow-lg" data-id="element-195">
          <p className="font-bold text-white mb-3 text-2xl" data-id="element-196">P.D:</p>
          <p className="mb-8 text-lg" data-id="element-197">
            No es falta de capacidad.
            <br data-id="element-198" />
            <span className="font-bold underline text-white" data-id="element-199">
              Es falta de sistema.
            </span>
          </p>

          <p className="font-bold text-white mb-3 text-2xl" data-id="element-200">P.P.D:</p>
          <p className="text-lg mb-6" data-id="element-201">
            Este precio no va a estar mucho tiempo más.
          </p>

          <a href="[CART_LINK]" className="text-brand-red font-bold hover:underline" data-id="element-202">
            → Acceder ahora antes de que suba
          </a>
        </div>
      </div>
    </motion.section>;
}